<template>
  <div id="login">

    <div class="app-container app-theme-white body-tabs-shadow">

      <div class="h-100">

        <div class="h-100 no-gutters row">

          <div class="h-100 d-flex justify-content-center align-items-center col-md-8 col-xl-6 mx-auto">

            <div class="w-100 mx-auto bg-white borda-login">

              <div class="mx-auto app-login-box col-sm-12 col-md-11">
                <div class="app-logo"></div>
                <h4 class="mb-0 font-titulos">
                  <span class="d-block">Recuperação de Senha</span>
                </h4>

                <h6 class="mt-3" v-if="mode === 'request'">Informe seu e-mail de acesso abaixo para iniciar o processo de troca de senha.</h6>

                <h6 class="mt-3" v-if="mode === 'submit'">Agora informe o PIN enviado para seu e-mail <br/> e informe a nova senha desejada</h6>

                <div class="divider row"></div>


                <validation-observer ref="validation" v-slot="{invalid,errors}">
                          <span class="display-none">
                            {{ errorList = errors }}
                            {{ isInvalid = invalid }}
                          </span>
                  <form @submit.prevent="onSubmit" class="fadeIn">

                      <t-form-wrapped :command="command" :status="localStatus">

                        <transition name="slide-fade" mode="out-in">

                          <div v-if="!success" id="login-not-success">

                            <t-input :disabled="mode === 'submit' || formSubmit" label="E-mail de Acesso" required email v-model="form.username"/>

                            <div class="mt-2" v-if="mode === 'request'">
                              <a href="#" class="link-black" @click="helpUserAccessCode()">Você utiliza um Código ao invés de e-mail?</a>
                            </div>

                            <div v-if="mode==='submit'">

                              <t-input label="PIN" max-length="10" :disabled="formSubmit" required v-model="form.recoveryPin"/>

                              <t-input label="Nova senha" password-security max-length="20" :disabled="formSubmit" required v-model="form.password"/>

                            </div>


                            <div class="divider row"></div>

                            <div v-if="hasServerError !== ''"
                                 class="alert alert-danger fade show is-invalid-fast">
                              {{ hasServerError }}
                            </div>

                            <div class="d-flex justify-content-center bd-highlight mb-2 mt-4">

                              <div class="d-flex">


                                <t-button-save
                                    @save="onSubmit"
                                    style="padding-right: 90px; padding-left: 90px"
                                    :clicked="btnSaveClicked"
                                    :text="mode === 'request' ? 'Recuperar Senha' : 'Trocar Senha'"
                                    :disabled="formSubmit"
                                />

                              </div>

                            </div>

                          </div>

                        </transition>

                      </t-form-wrapped>

                  </form>
                </validation-observer>



                <transition name="slide-fade" mode="out-in">
                  <div v-if="!success" class="d-flex justify-content-center">
                    <div class="row">


                      <b-link :to="'login'" tabindex="-1" class="btn-lg btn btn-link" v-show="!btnSaveClicked">
                        Voltar para o login
                      </b-link>

                    </div>
                  </div>
                </transition>


              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div id="curvas"></div>
  </div>
</template>
<script>
import ui from "@/assets/scripts/ui";
import userService from "@/services/modules/setting/User.service";

export default {
  name: 'Login',
  metaInfo() {
    return {
     title: "Recuperação de Senha"
    }
  },
  data() {
    return {
      success: false,
      command: 'insert',
      localStatus: '',
      mode: 'request',
      hasServerError: '',
      formSubmit: false,
      btnSaveClicked: false,
      form: {
        username: '',
        recoveryToken: '',
        recoveryPin: '',
        password: '',

      },
    }
  },
  created() {
    ui.defaultTemplate()
  },
  mounted() {



  },
  methods: {

    helpUserAccessCode(){
      ui.msg(this,"Informação","A recuperação de senha é possível somente com usuários que acessam a plataforma através de um e-mail. Desta forma, caso utilize um Código de Acesso será necessário solicitar auxilio para algum usuário Administrador para que troque seu PIN de acesso.")
    },

    //Necessário, pois foi realizado tratamento no valor antes de validação

    effectRedirectHome() {
      setTimeout(() => {
        this.redirectLogin()
      }, 1000)
    },
    redirectLogin() {
      this.$router.push({ name: 'login', query: { recovery: 'success' } })
    },

    async onSubmit() {

      this.localStatus = "subject"

      this.formSubmit = true
      this.btnSaveClicked = true

      this.$refs.validation.validate().then(success => {

        if (!success) {

          this.formSubmit = false
          this.btnSaveClicked = false

          return;
        }


        this.hasServerError = ''

        if (this.mode === 'request') {

          userService.recoveryRequest(this.form.username).then((response) => {

            this.formSubmit = false
            this.btnSaveClicked = false
            this.form.recoveryToken = response.recoveryToken

            this.mode = 'submit'

            /*this.success = true*/

          }).catch(error => {

            console.log("Erro externo " + error)
            this.hasServerError = 'Usuário inválido ou está inativo ou está bloqueado'
            this.formSubmit = false
            this.btnSaveClicked = false

          })


        } else {


          userService.recoverySubmit(this.form.username, this.form.recoveryToken, this.form.recoveryPin.replace(/\D/g,''), this.form.password).then(() => {

            this.redirectLogin();

          }).catch(error => {

            console.log("Erro externo " + error)
            this.localStatus = ''
            this.formSubmit = false
            this.btnSaveClicked = false
            this.form.username = ''
            this.hasServerError = 'Dados inválidos, será necessário reiniciar o processo'
            this.mode = 'request'

          })

        }

      });




    }
  }
}
</script>

<style scoped>

.app-container {
  background: url("https://static.onlaine.com.br/images/curvas.png") no-repeat right 600px;
}

.borda-login {
  border: solid 1px #CCC;
  border-radius: 5px;
  padding-top: 5%;
  padding-bottom: 5%;
  max-width: 800px;
  box-shadow: 0px 0px 15px 15px #FFF;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.icon-stores {
  opacity: 0.7;
  transition: all 300ms;
  width: 100px;
}

.icon-stores:hover {
  opacity: 0.9;
  cursor: pointer;
}

</style>
